import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { CouponInterface } from 'common/types/entities/CouponInterface'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { BorderStyleEnum } from 'common/types/styleTypes'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export const createCoupon = (
  parentId: string,
  placeholder?: string,
  buttonText?: string,
  masterBlockId?: MasterBlockId,
): CouponInterface => ({
  ...generateBaseEntity(EntityTypeEnum.Coupon, parentId, masterBlockId),
  button: {
    fontSize: 18,
    mobileFontSize: 14,
    text: buttonText ?? '',
    backgroundColor: 'rgba(68,68,68,1)',
    color: 'rgba(255, 255, 255, 1)',
    border: {
      radius: 4,
      style: BorderStyleEnum.solid,
      color: 'rgba(68,68,68,1)',
      width: 1,
    },
  },
  field: {
    fontSize: 18,
    mobileFontSize: 14,
    placeholder: placeholder ?? '',
    color: 'rgba(68, 68, 68, 1)',
    border: {
      radius: 4,
      style: BorderStyleEnum.solid,
      color: 'rgba(68,68,68,1)',
      width: 1,
    },
  },
})
